/**
 * PrenotazionePage - Page Shell
 * Form modifica prenotazione
 */

import { useParams } from "react-router-dom";
import { useState } from "react";
import { PrenotazioneForm } from "@/features/prenotazioni";

export default function PrenotazionePage() {
  const { id } = useParams<{ id: string }>();
  const [open, setOpen] = useState(true);
  
  return (
    <PrenotazioneForm 
      id={id}
      open={open}
      onOpenChange={setOpen}
      onSaved={() => {
        window.location.href = "/prenotazioni";
      }}
    />
  );
}
